var constants = require('../constants');
var initialState = require('../../initialState');

var newsletter = function(state, action) {
    var newstate = Object.assign({}, state);
    switch (action.type) {
        case constants.NEWSLETTER_SIGNUP_REQUEST:
            newstate.isFetching = true;
            return newstate;
        case constants.NEWSLETTER_SIGNUP_SUCCESS:
            newstate.isFetching = false;
            newstate.items = action.data;
            newstate.error = {};
            return newstate;
        case constants.NEWSLETTER_SIGNUP_FAILURE:
            newstate.isFetching = false;
            newstate.error = action.errors;
            return newstate;
        case constants.NEWSLETTER_CLEAR_ERROR:
            newstate.error = {};
            return newstate;
        default:
            return state || initialState.newsletter;
    }
}

module.exports = newsletter;



// WEBPACK FOOTER //
// ./src/common/modules/newsletter/reducers/newsletter.js